import empty from './empty'

export default function (routes) {
    return function (param) {
        const fn = routes[param] || empty;
        return fn.call(this, param);
    }
}
